import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { PlannerService } from 'src/app/planner/services/planner.service';
import { PlanStatus } from '../../constants/PlanStatus.const';

@Component({
  selector: 'plan-confirmation',
  templateUrl: './plan-confirmation.component.html',
  styleUrls: ['./plan-confirmation.component.scss'],
  providers: [
    PlannerService
  ]
})
export class PlanConfirmationComponent implements OnInit {
  planDetail: any;
  planStatus: any = PlanStatus;
  formTitle: string = "Plan Summary";
  showPlanSettings: boolean = false;
  showDigitalVideoFormatSettings: boolean = false;
  showOptionalConstraints: boolean = false;

  constructor(
    private plannerService: PlannerService,
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.planDetail = this.route.snapshot.data.planDetails;
  }

  backToList(): void {
    this.plannerService.redirectToList(this.planDetail.advertiserId || this.activatedRoute.snapshot.queryParams['advertiserId'],
      this.planDetail.marketId || this.activatedRoute.snapshot.queryParams['marketId']);
  }

  editPlan(plannerId): void {
    this.router.navigate(['planner/edit', plannerId], {
      queryParams: {
        advertiserId: this.planDetail.advertiserId || this.activatedRoute.snapshot.queryParams['advertiserId'],
        marketId: this.planDetail.marketId || this.activatedRoute.snapshot.queryParams['marketId']
      }
    });
  }

  isObjectEmpty(obj): boolean {
    return _.isEmpty(obj);
  }
}